export const getTextSnippet = (text: string, maxLength: number = 10) => {
  if (!text) {
    return ''
  }

  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
}

export const getUrlPrefix = (url: string): string | null => {
  const match = url.match(/^([^/]+)\//)
  return match ? match[1] : null
}
